module.exports = __webpack_public_path__ + "static/media/house-1.e65731aa.jpeg";